import { render } from "./PasswordChangeSection.vue?vue&type=template&id=27420808&scoped=true"
import script from "./PasswordChangeSection.vue?vue&type=script&lang=js"
export * from "./PasswordChangeSection.vue?vue&type=script&lang=js"

import "./PasswordChangeSection.vue?vue&type=style&index=0&id=27420808&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27420808"]])

export default __exports__